import { ICartItem } from "../store/slices/cartSlice";
import { IProduct } from "../types/product";
import { ICombo } from "../types/combo";

type WholesalePriceTier = {
    quantity: number;
    sale_price: number;
};

const getWholesaleSalePrice = (
    basePrice: number,
    quantity: number,
    wholesaleUpto?: number,
    wholesalePrice?: WholesalePriceTier[]
): number => {
    if (!wholesaleUpto || wholesaleUpto <= 0 || !wholesalePrice || wholesalePrice.length === 0) {
        return basePrice;
    }

    const normalizedQuantity = Number(quantity) || 0;
    const matchedTier = wholesalePrice.reduce<WholesalePriceTier | null>((best, tier) => {
        const tierQuantity = Number(tier.quantity) || 0;
        if (normalizedQuantity < tierQuantity) {
            return best;
        }
        if (!best || tierQuantity > best.quantity) {
            return tier;
        }
        return best;
    }, null);

    return matchedTier ? Number(matchedTier.sale_price) : basePrice;
};

export const getCartItemUnitPrice = (item: ICartItem): number => {
    if (item.type !== "product") {
        return item.price_sale;
    }

    return getWholesaleSalePrice(
        item.price_sale,
        item.quantity,
        item.wholesale_upto,
        item.wholesale_price
    );
};

export const getProductUnitPriceByQuantity = (product: IProduct, quantity: number): number => {
    return getWholesaleSalePrice(
        product.price_sale,
        quantity,
        product.wholesale_upto,
        product.wholesale_price
    );
};

export const formatProductInCart = (item: IProduct | ICombo, type: "product" | "combo"): ICartItem => {
    if (type === "product") {
        const product = item as IProduct;
        return {
            id: product.id,
            name: product.name,
            price_sale: product.price_sale,
            quantity: 1,
            parent_id: product.parent_id,
            type: type,
            unit_price: product.unit_price,
            wholesale_upto: Number(product.wholesale_upto) || 0,
            wholesale_price: Array.isArray(product.wholesale_price) ? product.wholesale_price : [],
            package_height: +product.height || 0,
            package_width: +product.width || 0,
            package_length: +product.length || 0,
            weight: +product.weight || 0,
        }
    }
    const combo = item as ICombo;
    return {
        id: combo.id,
        name: combo.name,
        price_sale: combo.price_sale,
        parent_id: combo.id,
        quantity: 1,
        type: type,
        unit_price: combo.combo_price,
        wholesale_upto: 0,
        wholesale_price: [],
        package_height: combo.total_height,
        package_width: combo.total_width,
        package_length: combo.total_length,
        weight: combo.total_weight,
    }
}